import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Suspense } from 'react';
import RouteTabsItemClient from './RouteTabsItemClient';
interface RouteTabsItemProps {
  children: ReactNode;
  path: string;
  className?: string;
  subPath?: string;
  isAuthCheck?: boolean;
  onClick?: () => void;
  disableActiveStyle?: boolean;
  matchingPaths?: string[];
}
export default function RouteTabsItem(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <button type="button" className="mr-10 border-b-0 pb-4 text-colorFg01"><p className="mx-1 whitespace-nowrap" /></button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Suspense fallback={t0}><RouteTabsItemClient {...props} /></Suspense>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}